import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const DetectorHeader = () => (
  <motion.header
    data-testid="detector-page-nav"
    initial={{ y: -40, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 0.9, ease: EASE, delay: 0.1 }}
    className="relative z-40 flex items-center justify-between px-6 lg:px-14 py-5 border-b border-white/[0.06] bg-black/60 backdrop-blur-md"
  >
    <Link to="/" data-testid="detector-nav-wordmark" className="flex items-center gap-3">
      <span className="w-2 h-2 bg-[#8A2BE2] rotate-45" />
      <span className="font-display text-2xl tracking-[0.3em] text-white">INSSUX</span>
    </Link>

    <Link
      to="/"
      data-testid="detector-nav-back"
      className="group flex items-center gap-2 font-display text-xs tracking-[0.3em] text-[#FFD166] border border-[#FFD166]/50 px-5 py-2.5 hover:bg-[#FFD166]/10 hover:border-[#FFD166] transition-colors duration-300"
    >
      <ArrowLeft size={13} className="transition-transform duration-300 group-hover:-translate-x-1" />
      BACK TO SITE
    </Link>
  </motion.header>
);

export default DetectorHeader;
